module.exports = __webpack_public_path__ + "static/media/reward3.632f6ed4.png";